import { forwardRef, ForwardedRef } from 'react';
import { Props } from '@blueprint/button/dist/Button.types';

import { LoaderIcon } from './LoaderIcon';
import { StyledButtonWithLoading } from './ButtonWithLoading.styles';

interface ButtonWithLoadingSelfProps extends Props {
    isLoading?: boolean;
    loadingText?: string;
    smallIcon?: boolean;
}

export type ButtonWithLoadingProps = ButtonWithLoadingSelfProps &
    JSX.IntrinsicElements['button'];

export const ButtonWithLoading = forwardRef(
    (
        {
            isLoading,
            loadingText = 'Loading',
            smallIcon,
            children,
            ...props
        }: ButtonWithLoadingProps,
        ref: ForwardedRef<HTMLButtonElement>
    ) => (
        <StyledButtonWithLoading
            aria-live="polite"
            isLoading={isLoading}
            {...props}
            ref={ref}
        >
            {isLoading ? (
                <>
                    <LoaderIcon
                        data-testid="spinner-icon"
                        aria-hidden
                        width={smallIcon ? 20 : 48}
                        height={smallIcon ? 20 : 48}
                    />
                    <span>{loadingText}</span>
                </>
            ) : (
                children
            )}
        </StyledButtonWithLoading>
    )
);
